import { agendaModuleRepo } from "@/repositories/agendaModuleRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";
import { map } from "rxjs";
import { teamFilter, type TeamIdOrOrg } from "./common";

export const useGetAgendaModule = (
  tenantId: string,
  agendaModuleId: string
) => {
  return useObservable(
    () => agendaModuleRepo.get(tenantId, agendaModuleId),
    [tenantId, agendaModuleId]
  );
};

export const useAgendaModuleList = (tenantId: string, teamId: TeamIdOrOrg) => {
  return useObservable(
    () => agendaModuleRepo.list(tenantId).pipe(map(teamFilter(teamId))),
    [tenantId, teamId]
  );
};
